import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useUserProfileQuery } from '../../features/auth/authApi';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from '../../helpers/permissions';

// Admin-only route guard. Like PrivateRoute it waits for the profile to load,
// but it additionally redirects non-admins back to their courses instead of
// rendering admin tooling. Backend endpoints are still admin-gated — this is
// the UX layer, not the security boundary.
const AdminRoute = ({ children }) => {
    const { data: user, isSuccess, isFetching } =
        useUserProfileQuery('userDetails');
    const navigate = useNavigate();

    const loaded = isSuccess && user && Object.keys(user).length !== 0;
    const userIsAdmin = loaded && isAdmin(user);

    useEffect(() => {
        if (loaded && !userIsAdmin) {
            navigate('/app/courses');
        }
    }, [loaded, userIsAdmin]);

    if (isFetching || !loaded) {
        return (
            <div
                style={{
                    margin: 0,
                    width: '100%',
                    textAlign: 'center',
                    marginTop: '40vh',
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    if (!userIsAdmin) {
        return null;
    }

    return children;
};

export default AdminRoute;
